import styled from 'styled-components';

export const AvatarWrapper = styled.div`
  width: 40px;
  height: 40px;
  position: relative;
`;

export const MobileConfigButtonWrapper = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  transition: 200ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  bottom: -8px;
  right: -8px;
`;

export const PlatinumSubscriptionIconWrapper = styled.div`
  position: absolute;
  transition: 200ms;
  bottom: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.green[500]};
  border: 1px solid ${({ theme }) => theme.neutral[1000]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  top: -8px;
`;
